import React, { memo } from 'react';
import PropTypes from 'prop-types';
import ToolTip from '../../ToolTipIcon/ToolTip';

const EddJointActions = memo(props => {
  const {
    filesSelected,
    deleteClicked,
    importClicked,
    validateClicked,
    downloadClicked,
    scheduleClicked,
  } = props;

  return (
    <div data-test="edd-joint-actions" className="flex items-center justify-center h-full ">
      <div className="flex ml-8 space-x-8 items-center bg-transparent z-40  mr-8 ">
        <ToolTip toolText="Number of items selected" placement="bottom">
          <div className="flex justify-center items-center">
            <div className="flex w-6 h-6 justify-center  ml-2 items-center font-semibold text-white bg-green-600 rounded-md">
              {filesSelected.length}
            </div>
            <p className="text-sm ml-2">files selected </p>
          </div>
        </ToolTip>

        <ToolTip toolText="Select one or more files and revalidate" placement="bottom">
          <button
            type="button"
            className="duration-500 hover:scale-105 w-[50px] text-[#0A364B] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
            data-test="edd-joint-action-revalidate"
            onClick={validateClicked}
          >
            <img
              src="/assets/images/icons/cloud-check.svg"
              alt="Re-Validate"
              className="w-[30px] h-[30px] max-w-[30px] max-h-[30px]"
            />
          </button>
        </ToolTip>

        <ToolTip toolText="Select one or more items to delete" placement="bottom">
          <button
            data-test="edd-joint-action-delete"
            type="button"
            className="duration-500 hover:scale-105 w-[50px] text-[#0A364B] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
            onClick={deleteClicked}
          >
            <img
              src="/assets/images/icons/trash_outline.svg"
              alt="Delete"
              className="w-[30px] h-[30px] max-w-[30px] max-h-[30px]"
            />
          </button>
        </ToolTip>

        <ToolTip toolText="Select one or more items to download">
          <button
            data-test="edd-joint-action-download"
            type="button"
            className="duration-500 hover:scale-105 w-[50px] text-[#0A364B] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
            onClick={downloadClicked}
          >
            <img
              src="/assets/images/icons/download.svg"
              alt="Download"
              className="w-[30px] h-[30px] max-w-[30px] max-h-[30px]"
            />
          </button>
        </ToolTip>

        <ToolTip toolText="Import Files" placement="bottom">
          <button
            data-test="edd-joint-action-import"
            type="button"
            className="duration-500 hover:scale-105 w-[50px] text-[#0A364B] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
            onClick={importClicked}
          >
            <img
              src="/assets/images/icons/file-import.svg"
              alt="Import"
              className="w-[30px] h-[30px] max-w-[30px] max-h-[30px]"
            />
          </button>
        </ToolTip>

        <ToolTip toolText="Schedule an import" placement="bottom">
          <button
            data-test="edd-joint-action-schedule"
            type="button"
            className="duration-500 hover:scale-105 w-[50px] text-[#0A364B] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
            onClick={scheduleClicked}
          >
            <img
              src="/assets/images/icons/schedule.svg"
              alt="Schedule"
              className="w-[30px] h-[30px] max-w-[30px] max-h-[30px]"
            />
          </button>
        </ToolTip>
      </div>
    </div>
  );
});

EddJointActions.propTypes = {
  filesSelected: PropTypes.array,
  deleteClicked: PropTypes.func,
  importClicked: PropTypes.func,
  validateClicked: PropTypes.func,
  downloadClicked: PropTypes.func,
  scheduleClicked: PropTypes.func,
};

export default EddJointActions;
